const TOKEN_HEADER_NAME = 'X-FOM-Token'

export class FomToken {
  constructor(response) {
    this.token = response?.headers.get(TOKEN_HEADER_NAME)
  }

  appendToObject(headers) {
    if (!this.token || !headers || typeof headers !== 'object') {
      return headers
    }

    headers[TOKEN_HEADER_NAME] = this.token

    return headers
  }
}
